<template>
  <div v-loading="fullLoading">
    <el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true">
          <el-form-item align="right">
            <el-button type="info" size="medium" @click="addNoteClick()">Add Note</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="notesTable" stripe style="width: 100%; margin-bottom: 10px; font-size: 1rem"
          @cell-click="noteEditClick" cell-class-name="cellStyle">
          <!-- <el-table-column v-show="false" :min-width="70" prop="noteId" label="ID"></el-table-column> -->
          <el-table-column :min-width="15" prop="created" label="Date Created" sortable></el-table-column>
          <el-table-column :min-width="25" prop="email" label="User Created"></el-table-column>
          <el-table-column :min-width="70" prop="notes" label="Note"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-dialog title="Note" :visible.sync="noteDialog.visible">
        <el-form :model="noteDialog.form" v-loading="noteDialog.loading" @submit.native.prevent>
          <el-form-item>
            <el-input placeholder="New Value" v-model="noteDialog.form.note" type="textarea" autosize
              style="margin-top: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-top: 10px" @click="noteDialog.visible = false">Cancel</el-button>
            <el-button type="primary" style="margin-top: 10px" @click="NoteDialogHandler">Save</el-button>
            <el-button v-if="!noteDialog.form.newNote" type="primary" style="margin-top: 10px; float:right;"
              @click="NoteDeleteHandler">Delete Note</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import Axios from "axios"
import NotesService from "@/api/notes.service"
import ApartmentsService from "@/api/apartments.service"

export default {
  components: {},
  props: {},
  data() {
    return {
      fullLoading: false,
      user: this.$session.get("User"),
      noteDialog: {
        visible: false,
        idVisible: false,
        form: {
          noteId: "ddddd",
          dateCreated: "",
          userCreated: "",
          note: "",
          newNote: false
        },
        valveSetOptionsVisible: false,
        manualSetOptionsVisible: false,
        timeout: 0,
        loading: false
      },
      dataLoaded: false,
      notesTable: [
      ],

    }
  },
  methods: {
    NoteDeleteHandler() {
      NotesService.deleteZoneNote(this.noteDialog.form.noteId).then(() => {
        this.getData();
      })
      this.noteDialog.visible = false
    },
    addNoteClick() {
      this.noteDialog.form.note = "";
      this.noteDialog.form.newNote = true;
      this.noteDialog.visible = true
    },
    noteEditClick(row, column, cell, event) {
      this.noteDialog.form.noteId = row.id;
      this.noteDialog.form.dateCreated = row.created;
      this.noteDialog.form.userCreated = row.email;
      this.noteDialog.form.note = row.notes;
      this.noteDialog.form.newNote = false;
      this.noteDialog.visible = true
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    NoteDialogHandler() {
      if (this.noteDialog.form.newNote) {
        NotesService.addZoneNote(this.user.activeZone, this.user.email, this.noteDialog.form.note).then(() => {
          this.getData();
        })
      } else {
        NotesService.editZoneNote(this.noteDialog.form.noteId, this.noteDialog.form.note).then(() => {
          this.getData();
        })
      }
      this.noteDialog.visible = false
    },


    onSubmit() {
      console.log("submit!")
    },

    getData() {
      if (!this.$auth.isAuthenticated()) this.$auth.login()
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([
        NotesService.getZoneNotes(this.user.activeZone),
      ])
        .then(
          Axios.spread((ZoneNotesResponse) => {
            console.log(ZoneNotesResponse.data)
            this.notesTable = ZoneNotesResponse.data
            this.dataLoaded = true
          })
        )
        .catch((err) => {
          this.sysHeatStatusTable[0].network = "Error in Server and/or Panel"
          console.log(err)
        })
    }

  },
  created() { },
  mounted() {
    this.getData()
    //this.polling = setInterval(this.getData, 10000)
  },
  beforeDestroy() {
    //clearInterval(this.polling)
  }
}
</script>

<style>
.el-table td {
  font-size: medium;
  white-space: pre-wrap;
  word-wrap: break-word
}

.el-table__body-wrapper {
  overflow: hidden;
}

.el-table .cell {
  white-space: pre-wrap
}
</style>



// WEBPACK FOOTER //
// Notes.vue?27718686